module.exports = __webpack_public_path__ + "img/skinxs-gray-icon.2e2f17eb.svg";